import { Site } from '@/core/entities';
import { Button, ButtonProps, Stack, styled } from '@mui/material';
import { FunctionComponent, ReactElement } from 'react';

const ShowMoreButton = styled(Button)<ButtonProps>(() => ({
	minWidth: 0,
	backgroundColor: 'transparent',
	padding: '4px 5px',
	lineHeight: 1.43,
	fontSize: '14px',
	fontWeight: 'normal',
	textTransform: 'none',
	'&:hover': {
		backgroundColor: 'transparent',
	},
}));

interface UserSiteShowMoreButtonProps {
	count: number;
	onClick: () => void;
}

const UserSiteShowMoreButton: FunctionComponent<UserSiteShowMoreButtonProps> = ({
	count,
	onClick,
}): ReactElement => (
	<ShowMoreButton disableRipple size="small" variant="text" onClick={onClick}>
		{`+${count} more`}
	</ShowMoreButton>
);

interface SitesCellProps {
	sites?: Site[];
	onClick: () => void;
}

const SitesCell: FunctionComponent<SitesCellProps> = ({ sites, onClick }): ReactElement => {
	const firstSite = sites?.[0];
	const showMoreLength = sites?.length ? sites.length - 1 : undefined;

	return (
		<Stack direction="row" spacing={0.5} alignItems="center">
			<span>{firstSite?.name}</span>
			{!!showMoreLength && showMoreLength > 0 && (
				<UserSiteShowMoreButton count={showMoreLength} onClick={onClick} />
			)}
		</Stack>
	);
};

export default SitesCell;
